import { render, staticRenderFns } from "./channelColumn.vue?vue&type=template&id=4a6413c1&scoped=true&"
import script from "./channelColumn.vue?vue&type=script&lang=js&"
export * from "./channelColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6413c1",
  null
  
)

export default component.exports